import { Router } from '@tyro/router/router';

import { getRoutes as getAssessmentRoutes } from '@tyro/assessments';
import { getRoutes as getAttendanceRoutes } from '@tyro/attendance';
import { getRoutes as getCalendarRoutes } from '@tyro/calendar';
import { getRoutes as getClassListManagerRoutes } from '@tyro/class-list-manager';
import { getRoutes as getFeeRoutes } from '@tyro/fees';
import { getRoutes as getFormsRoutes } from '@tyro/forms';
import { getRoutes as getGroupRoutes } from '@tyro/groups';
import type { TFunction } from '@tyro/i18n';
import { getRoutes as getInfoRequestsRoutes } from '@tyro/info-requests';
import { getRoutes as getMailRoutes } from '@tyro/mail';
import { getRoutes as getNoticeBoardRoutes } from '@tyro/notice-board';
import { getRoutes as getPeopleRoutes } from '@tyro/people';
import { getRoutes as getPrintingRoutes } from '@tyro/printing';
import { getRoutes as getReportingRoutes } from '@tyro/reporting';
import { getRoutes as getRoomBookingRoutes } from '@tyro/room-booking';
import { getRoutes as getRulesRoutes } from '@tyro/rules';
import { getRoutes as getSchoolActivitiesRoutes } from '@tyro/school-activities';
import { getRoutes as getSettingsRoutes } from '@tyro/settings';
import { getRoutes as getSmsRoutes } from '@tyro/sms';
import { getRoutes as getSubjectOptionsRoutes } from '@tyro/subject-options';
import { getRoutes as getSubstitutionRoutes } from '@tyro/substitution';
import { getRoutes as getTemplatesRoutes } from '@tyro/templates';
import { getRoutes as getTimetableRoutes } from '@tyro/timetable';
import { getRoutes as getAdminRoutes } from '@tyro/tyro-admin';
import { getRoutes as getTyroTuition } from '@tyro/tyro-tuition';

import { routes as authRoutes } from '@tyro/authentication';
import { Shell } from './components/shell';
import { getShellRoutes } from './routes';

const mockTFunction = ((key: string) => key) as TFunction<
  'navigation'[],
  undefined,
  'navigation'[]
>;

export const getNavCategories = (t: TFunction<'navigation'[]>) => [
  ...getShellRoutes(t),
  ...getCalendarRoutes(t),
  ...getNoticeBoardRoutes(t),
  ...getClassListManagerRoutes(t),
  ...getGroupRoutes(t),
  ...getAttendanceRoutes(t),
  ...getMailRoutes(t),
  ...getFeeRoutes(t),
  ...getInfoRequestsRoutes(t),
  ...getAssessmentRoutes(t),
  ...getSchoolActivitiesRoutes(t),
  ...getRoomBookingRoutes(t),
  ...getPeopleRoutes(t),
  ...getReportingRoutes(t),
  ...getTemplatesRoutes(t),
  ...getSmsRoutes(t),
  ...getSubjectOptionsRoutes(t),
  ...getSubstitutionRoutes(t),
  ...getTimetableRoutes(t),
  ...getTyroTuition(t),
  ...getPrintingRoutes(t),
  ...getFormsRoutes(t),
  ...getRulesRoutes(t),
  ...getSettingsRoutes(t),
  ...getAdminRoutes(t),
];

export function AppRouter() {
  return (
    <Router
      navCategories={getNavCategories(mockTFunction)}
      Shell={Shell}
      additionalRoutes={authRoutes}
    />
  );
}
